<!-- 页面内容 -->
<template>
	<div
		class="w1440"
		:class="{isFull: userStore.isOpenScreenFull}"
		style="margin: 0 auto;min-width:1007px;"
	>
		<!-- max-width: 1320px; -->
		<slot />
	</div>
</template>

<script lang="ts" setup>
import { useUserStore } from '@/store/user';
const userStore = useUserStore();
</script>

<style lang='scss' scoped>
.w1440 {
	width: 1440px;
	&.isFull {
		width: 90%;
	}
}
</style>